import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Location as RouteLocation } from 'vue-router';
import Image from './item/image';
import ItemSingle from './item/single';
import ItemDouble from './item/double';
import { Items } from './types';
import OrganizationSingleItem from "@/components/parts/catalog/list/single_item/OrganizationSingleItem.vue";

@Component({
  components: {
    OrganizationSingleItem,
    ItemSingle,
    ItemDouble,
  },
})
export default class ComponentPartCatalogList extends Mixins(Image) {
  @Prop({ type: String, default: 'Показать все' })
  buttonText: string;

  @Prop({ type: Boolean, default: false })
  buttonVisible: boolean;

  @Prop({ type: Boolean, default: true })
  constrainNameHeight: boolean;

  @Prop({ type: [Function, Boolean], default: false })
  doubler: Function | boolean;

  @Prop({ type: Array, default: () => [] })
  items: Items;

  @Prop({ type: Object, default: null })
  linkTo: RouteLocation;

  @Prop({ type: String, default: '' })
  title: string;

  @Prop({ type: Boolean, default: false })
  usePadding: boolean;

  @Prop({ type: Boolean, default: true })
  visible: boolean;

  @Prop({ type: Boolean, default: false })
  showClose?: boolean;

  isMounted = false;

  get hasAfterSlot(): boolean {
    const { left, after, right } = this.$slots;
    return !!(left || after || right);
  }

  get listItems() {
    const { items, imageBgColor, imageBgDefault, imageBgSize, showClose } =
      this;

    if (!items) return [];

    return items.map((item, index) => {
      const {
        id,
        ovz,
        image: { small, large },
      } = item;
      const doubled =
        typeof this.doubler === 'function'
          ? this.doubler.call(this, index)
          : false;
      const badgeData: Array<string> = [];

      if (ovz) badgeData.push('ovz');
      return {
        id,
        doubled,
        bind: {
          ...item,
          showClose,
          imageBgDefault,
          imageBgColor,
          imageBgSize,
          badge: badgeData,
          img: doubled ? large || small : small,
        },
      };
    });
  }

  onDelete(index: number) {
    this.$emit('delete', index);
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/script.ts